import { render, staticRenderFns } from "./Tentang.vue?vue&type=template&id=1c0af672&scoped=true"
import script from "./Tentang.vue?vue&type=script&lang=js"
export * from "./Tentang.vue?vue&type=script&lang=js"
import style0 from "./Tentang.vue?vue&type=style&index=0&id=1c0af672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0af672",
  null
  
)

export default component.exports